var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ListingLocation"},[_c('h5',[_vm._v(_vm._s(_vm._f("language")('Location')))]),_c('GmapMap',{staticStyle:{"width":"100%","height":"300px"},attrs:{"center":{
        lat:parseFloat(_vm.property.int_latitude),
        lng:parseFloat(_vm.property.int_longitude)
    },"zoom":15,"map-type-id":"roadmap","options":_vm.mapStyle}},[_c('GmapMarker',{attrs:{"position":{
        lat:parseFloat(_vm.property.int_latitude),
        lng:parseFloat(_vm.property.int_longitude)
      },"clickable":false,"draggable":false,"icon":_vm.icon}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }